import { Box, Heading } from '@chakra-ui/react'
import { FC } from 'react'

const LayoutFiltersHeader: FC = () => {
  return (
    <Box h="72px" borderBottom="solid 1px" borderColor="gray.200" px={4}>
      <Heading fontSize="24px" fontWeight="400" lineHeight="72px">
        Filtros
      </Heading>
    </Box>
  )
}

export default LayoutFiltersHeader
